module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iArl9"))).then(() => parcelRequire('cvs7o'));